/**
 * Soft-voided and absent records remain visible in history but cannot trigger rules.
 */
export const isThresholdCountable = (consequence = {}) => {
  const status = String(consequence.status || '').toLowerCase();
  const attendanceStatus = String(
    consequence.attendanceStatus || ''
  ).toLowerCase();
  const adjudicationStatus = String(
    consequence.adjudicationStatus || ''
  ).toLowerCase();
  return consequence.undone !== true &&
    consequence.voided !== true &&
    consequence.deleted !== true &&
    consequence.isDeleted !== true &&
    status !== 'voided' &&
    status !== 'deleted' &&
    status !== 'cancelled' &&
    (status !== 'absent' || attendanceStatus === 'excused') &&
    attendanceStatus !== 'absent' &&
    adjudicationStatus !== 'voided';
};
